import React, { useEffect, useState } from "react";
import SettingContainer from "../SettingContainer";
import ActivityLoader from "../../Common/ActivityLoader";
import Notification from "../../Common/Notification";
import { useTheme } from "../../../DataStore/ThemeContext";
import ajaxConfig from "../../../util/remote/ajaxConfig";

const InterfaceConfig = () => {
  const { setNotify, openSettings } = useTheme();
  const [interfaces, setInterfaces] = useState(null);

  useEffect(() => {
    getInterfaces();
  }, []);

  const handleRefresh = () => {
    getInterfaces();
  };

  const getInterfaces = async () => {
    let server_response = await ajaxConfig.fetchInterfaces();
    if (server_response.status === "OK") {
      setInterfaces(server_response.details);
    } else {
      setNotify(
        <Notification
          message={server_response.message}
          type="danger"
          closable={false}
        />
      );
    }
  };

  const truncateText = (text, maxLength) => {
    if(!text) return '';
    if (text.length > maxLength) {
      return (
        <span title={text}>
          {text.substring(0, maxLength)}...
        </span>
      );
    }
    return text;
  };

  const menu = () => (
    <>
      <button
        type="button"
        tabIndex="0"
        className="dropdown-item"
        onClick={handleRefresh}
      >
        <i className="dropdown-icon fa fa-refresh"> </i>
        <span>Refresh</span>
      </button>
    </>
  );

  const handleConfigure = (record) => {
    record.onComplete = handleRefresh;
    openSettings("External Interface Settings", "ConfigInterface", record);
  }

  return (
    <SettingContainer
      title="External Interfaces"
      icon="fa fa-external-link-alt"
      Menu={menu}
    >
      
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Interface Name</th>
                    <th>Interface Code</th>
                    <th>API</th>
                    <th>Username</th>
                    <th>Password</th>
                    <th>API Key</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(interfaces) && interfaces.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.interface_name}</td>
                      <td>{item.interface_code}</td>
                      <td>{truncateText(item.url, 15)}</td>
                      <td>{item.username}</td>
                      <td>{"********"}</td>
                      <td>{truncateText(item.api_key, 10)}</td>
                      <td>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => handleConfigure(item)}>
                          Configure
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
      
        {!interfaces && <ActivityLoader />}
        </SettingContainer>
  );
};

export default InterfaceConfig;
